module.exports = __webpack_public_path__ + "static/samuel-s-daggett-desktop.54292dd1.webp";